import { render, staticRenderFns } from "./VehiculosGrid.vue?vue&type=template&id=a597d1aa&"
import script from "./VehiculosGrid.vue?vue&type=script&lang=ts&"
export * from "./VehiculosGrid.vue?vue&type=script&lang=ts&"
import style0 from "./VehiculosGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports